const camera = {
	// 9999: {
	// 	r: {
	// 		y: 0,
	// 		z: 0,
	// 	},
	// 	t: {
	// 		x: 0,
	// 		y: -100,
	// 	},
	// 	zoom: 1.5,
	// },

	1: {
		r: {
			y: 0,
			z: 5,
		},
		t: {
			x: 0,
			y: -100,
		},
		zoom: 1.5,
	},

	2: {
		r: {
			y: -40,
			z: -15,
		},
		t: {
			x: -20,
			y: -60,
		},
		zoom: 2,
	},

	3: {
		r: {
			y: -30,
			z: -10,
		},
		t: {
			x: -10,
			y: -55,
		},
		zoom: 2,
	},

	4: {
		r: {
			y: -30,
			z: -10,
		},
		t: {
			x: 10,
			y: -55,
		},
		zoom: 2,
	},

	5: {
		r: {
			y: -30,
			z: -10,
		},
		t: {
			x: 10,
			y: -55,
		},
		zoom: 2.2,
	},

	6: {
		r: {
			y: 30,
			z: -50,
		},
		t: {
			x: 0,
			y: 40,
		},
		zoom: 2.8,
	}


};


const folds = {

	1: {
		pF: [ 0, 0 ],
		pB: [ 0, 0 ],
		p5: [ 0, 0 ],
		p6: [ 0, 0 ],

		p1: [ 0, 0 ],
		p2: [ 0, 0 ],
		p3: [ 0, 0 ],
		p4: [ 0, 0 ],
	},

	2: {
		pF: [ 0, 0 ],
		pB: [ 70, 0 ],
		p5: [ -162, 0 ],
		p6: [ 90, 0 ],

		p1: [ 0, 0 ],
		p2: [ 70, 0 ],
		p3: [ -162, 0 ],
		p4: [ 90, 0 ],
	},

	3: {
		pF: [ 0, 18 ],
		pB: [ 70, 0 ],
		p5: [ -162, 0 ],
		p6: [ 90, 0 ],

		p1: [ 0, -18 ],
		p2: [ 70, 0 ],
		p3: [ -162, 0 ],
		p4: [ 90, 0 ],
	},

	4: {
		pF: [ 0, 25 ],
		pB: [ 52, 0 ],
		p5: [ -178, 0 ],
		p6: [ 130, 0 ],

		p1: [ 0, -25 ],
		p2: [ 130, 0 ],
		p3: [ -178, 0 ],
		p4: [ 52, 0 ],
	},

	5: {
		pF: [ 0, 80 ],
		pB: [ 12, 0 ],
		p5: [ -174, 0 ],
		p6: [ 160, 0 ],

		p1: [ 0, -80 ],
		p2: [ 160, 0 ],
		p3: [ -174, 0 ],
		p4: [ 12, 0 ],
	},

	6: {
		pF: [ -80, 89 ], // 90
		pB: [ -120, 0 ],
		p5: [ -178, 0 ],
		p6: [ 170, 0 ],

		p1: [ -80, -89 ], // -90
		p2: [ 170, 0 ],
		p3: [ -178, 0 ],
		p4: [ 170, 0 ],
	}

};


const colours = {

	1: {
		pF: 0,
		pB: 0.01,
		p5: 0.02,
		p6: 0.03,

		p1: 0,
		p2: 0.01,
		p3: 0.02,
		p4: 0.03,
	},

	2: {
		pF: 0.1,
		pB: 0,
		p5: 0.5,
		p6: 0.3,

		p1: 0.1,
		p2: 0,
		p3: 0.5,
		p4: 0.3,
	},

	3: {
		pF: 0.1,
		pB: 0,
		p5: 0.5,
		p6: 0.3,

		p1: 0.15,
		p2: 0,
		p3: 0.6,
		p4: 0.4,
	},

	4: {
		pF: 0,
		pB: 0.1,
		p5: 0.4,
		p6: 0.5,

		p1: 0.2,
		p2: 0.2,
		p3: 0.4,
		p4: 0.3,
	},

	5: {
		pF: 0.1,
		pB: 0.2,
		p5: 0.4,
		p6: 0.5,

		p1: 0.6,
		p2: 0.6,
		p3: 0.6,
		p4: 0.6,
	},

	6: {
		pF: 0,
		pB: 0.1,
		p5: 0.3,
		p6: 0,

		p1: 0.2,
		p2: -0.2,
		p3: 0.1,
		p4: -0.1,
	},

};


const scissorsRest = { y: 1000, z: 300 };

const scissors = {
	3: {
		y: 75,
		z: 100,
	},

	1: scissorsRest,
	2: scissorsRest,
	4: scissorsRest,
};